module.exports = __webpack_public_path__ + "img/doorLogo19.c97b9cfa.png";